import { ClipboardList, Ticket } from "lucide-react";
import { useSite } from "@/context/SiteContext";

const Btn = ({ url, icon: Icon, title, sub, testid, primary }) => {
  const base = "group flex w-full items-center gap-4 p-5 text-left transition-[background-color,transform] duration-200";
  if (!url) {
    return (
      <div className={`${base} border border-dashed border-line bg-pitch/40 cursor-not-allowed`} data-testid={`${testid}-pending`} aria-disabled="true">
        <Icon className="h-8 w-8 shrink-0 text-slate-500" />
        <div>
          <p className="font-display text-lg sm:text-xl font-black uppercase italic text-slate-300">{title}</p>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">Registration link coming soon</p>
        </div>
      </div>
    );
  }
  return (
    <a href={url} target="_blank" rel="noreferrer" data-testid={testid}
      className={`${base} hover:-translate-y-0.5 ${primary ? "bg-gold text-navy hover:bg-gold-dark" : "bg-white text-navy hover:bg-slate-200"}`}>
      <Icon className="h-8 w-8 shrink-0" />
      <div>
        <p className="font-display text-lg sm:text-xl font-black uppercase italic">{title}</p>
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] opacity-70">{sub}</p>
      </div>
    </a>
  );
};

export const RegisterButtons = () => {
  const { settings } = useSite();
  return (
    <div className="grid gap-3 sm:grid-cols-2" data-testid="registration-buttons">
      <Btn primary url={settings.jotform_url} icon={ClipboardList} title="Complete Player Registration" sub="Jotform" testid="register-jotform-button" />
      <Btn url={settings.eventbrite_url} icon={Ticket} title="Secure Your Spot" sub="Eventbrite" testid="register-eventbrite-button" />
    </div>
  );
};
